import script from "./UpLogTral.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpLogTral.vue?vue&type=script&lang=ts&setup=true"

import "./UpLogTral.vue?vue&type=style&index=0&id=e83039fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e83039fc"]])

export default __exports__